import {Header} from "../components/layout/header";
import {ExtraButtons} from "../components/extra-buttons";
import React from "react";
import {usePermission} from "../hooks";
import {
    EditDrawer,
    useGetIntervalSettings,
    useManageItems,
    getFormattedItems,
    getColumns
} from "../pages-lib/interval-custom-settings";
import {VisibilityProvider} from "../components/visibility-provider";
import styled from "styled-components";
import { Table as AntTable} from "antd";

export default function IntervalCustomSettings() {
    const { hasPermission } = usePermission()
    const [createDrawerState, setCreateDrawerState] = React.useState(false)
    const [editDrawerState, setEditDrawerState] = React.useState(false)

    function onSuccessCreate() {
        setCreateDrawerState(!createDrawerState)
    }

    function onSuccessEdit() {
        setEditDrawerState(!editDrawerState)
    }

    const {
        settingItems,
        pagination,
        isLoading,
        refetch: getIntervalSettings,
        handleTableChange,
        options
    } = useGetIntervalSettings()

    const {
        onCreate,
        onEdit,
        onEditItem,
        onDelete,
        editData
    } = useManageItems(
        getIntervalSettings,
        settingItems,
        onSuccessCreate,
        onSuccessEdit
    )

    const columns = getColumns(hasPermission("interval-custom-settings.delete") ? onDelete : null, hasPermission("interval-custom-settings.edit") ? onEditItem : null)

    return (
        <>
            <Header
                title={"Кастомная настройка интервалов"}
                extra={
                    <ExtraButtons
                        onCreate={hasPermission("interval-custom-settings.create") ? () => setCreateDrawerState(true) : undefined}
                        // onFilter={() => setFilterDrawerState(!filterDrawerState)}
                        // onSort={() => setSortableDrawerState(!sortableDrawerState)}
                        titles={{ onCreate: "Настроить интервал" }}
                    />
                }
            />

            <StyledTable
                dataSource={getFormattedItems(settingItems, options.pointOptions)}
                columns={columns}
                loading={isLoading}
                onChange={handleTableChange}
                pagination={pagination}
            />

            {hasPermission("interval-custom-settings.create") && (
                <VisibilityProvider visible={createDrawerState}>
                    <EditDrawer
                        title={"Добавить кастомный интервал"}
                        onClose={onSuccessCreate}
                        onSave={onCreate}
                        pointOptions={options.pointOptions}
                        loading={isLoading}
                    />
                </VisibilityProvider>
            )}

            {hasPermission("interval-custom-settings.edit") && (
                <VisibilityProvider visible={editDrawerState}>
                    <EditDrawer
                        title={"Редактирование кастомного интервала"}
                        onClose={onSuccessEdit}
                        initialValues={editData}
                        onSave={onEdit}
                        pointOptions={options.pointOptions}
                        loading={isLoading}
                    />
                </VisibilityProvider>
            )}
        </>
    )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }`